import React, { useEffect, useState } from "react";
import { processAndUpdateToken } from "../../Services/CommonFunctions";
import axios from "axios";
import { baseUrl } from "../../Services/Constants";
import CommonDataTable from "../CommonDataTable";
import { DefaultButton } from "@fluentui/react/lib/Button";
import NewReport from "../ReprocessDatePicker";
import { Dropdown } from "@fluentui/react";

const QuoteDeletionReport = ({ activeTab }) => {
    const [jobInstance, setJobInstance] = useState([]);
    const [brokeropton, setBrokeropton] = useState([]);
    const [selectedBroker, setSelectedBroker] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [searchClicked, setSearchClicked] = useState(false);
    const [msgVisible, setMsgVisible] = useState(false);
    const [msgClass, setMsgClass] = useState("");
    const [msgText, setMsgText] = useState("");
    const [jobId, setJobId] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [selectedOption, setSelectedOption] = useState("All Jobs");
    const [selectOption, setSelectOption] = useState("Welcome To Exdion");
    const [spreadsheetData, setSpreadsheetData] = useState(null);
    const [token, setToken] = useState(null);
    const [tableNames, setTableNames] = useState([]);
    const [isDatePickerDisabled, setIsDatePickerDisabled] = useState(true);

    useEffect(() => {
        // TokenRender();
        setBrokeropton();
        Dropdowndata();
        getData();

    }, []);

    const column = [
        {
            name: "Id",
            selector: (row, index) => index + 1,
            sortable: true,
            style: { fontSize: "11px !important" },
        },
        {
            name: "UserName",
            selector: (row) => {
                if (!row?.UserName) return "";
                const userName = row.UserName.split("@")[0];
                return userName.charAt(0).toUpperCase() + userName.slice(1);
            },
            sortable: true,
            style: { fontSize: "11px !important" },
        },
        {
            name: "Status",
            selector: (row) => {
                const status = row?.Status;
                const color =
                    status === "Processed"
                        ? "lightGreen"
                        : status === "Pending"
                            ? "royalBlue"
                            : status === "Failed"
                                ? "red"
                                : "black";
                return <div style={{ color }}>{status}</div>;
            },
            sortable: true,
            style: { fontSize: "11px !important" },
        },
        {
            name: "Input Date",
            selector: (row) => {
                if (row?.InputDate) {
                    const fromDate = row.InputDate.split(" - ")[0];

                    const [month, day, year] = fromDate.split("/");

                    const formattedDate = new Date(
                        `${year}-${month}-${day}`
                    ).toDateString();

                    return formattedDate;
                }
                return "";
            },
            sortable: true,
            style: { fontSize: "11px !important" },
        },
        {
            name: "CreatedOn Date",
            selector: (row) => {
                if (row.CreatedOn != null && row.CreatedOn != undefined) {
                    const createdDate = new Date(row.CreatedOn).toDateString();
                    return createdDate;
                } else {
                    return "";
                }
            },
            sortable: true,
            style: { fontSize: "11px !important" },
        },
        {
            name: "Export Excel",
            cell: (row) =>
                row?.Status === "Processed" ? (
                    <DefaultButton
                        onClick={(e) => {
                            exportData(e, row);
                        }}
                        text={
                            <span
                                style={{ color: "black", fontSize: "10px", fontWeight: "bold" }}
                            >
                                Export
                            </span>
                        }
                    />
                ) : null,
            style: { fontSize: "11px !important" },
        },
    ];
    const onBrokerChange = (brokerId) => {
        const tokenValue = sessionStorage.getItem("token");
        setSelectedBroker(brokerId);
        setToken(tokenValue);
        getData(brokerId);
        setIsDatePickerDisabled(false);
    };

    const TokenRender = () => {
        if (
            !(
                sessionStorage.getItem("userName") != null &&
                sessionStorage.getItem("userName") != undefined
            )
        ) {
            window.location.href = "/UnAuthorizedUser";
            return;
        }
        const loginData = {
            UserId: 0,
            UserName: "Exdion",
            Password: "Exdion@123",
        };
        axios
            .post(baseUrl + "/api/Authentication/login", loginData, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                if (response.status !== 200) {
                    throw new Error("Network response was not ok");
                }
                setToken(response.token);
                GetallJobinstance(response.data);
                Dropdowndata(response.data);
                sessionStorage.setItem("token", response.data);
            })
            .catch((error) => {
                // Handle any errors here
                // You can update your component state or show an error message.
            });
    };
    const GetallJobinstance = (token, broker) => {
        if (token && token.length >= 40) {
            document.body.classList.add("loading-indicator");
            var token = token;
            broker = broker == undefined ? null : broker;
            setToken(token);

            const headers = {
                Authorization: `Bearer ${token}`,
            };
            const extent = broker ? `?brokerId=${broker}` : "";
            const URL = baseUrl + `/api/Defaultdatum/GetallJobinstance${extent}`;
            axios
                .get(URL, { headers })
                .then((response) => {
                    if (response.status !== 200) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    return response.data;
                })
                .then((data) => {
                    setJobInstance(data);
                })
                .catch((error) => {
                    setMsgVisible(true);
                    setMsgClass("alert error");
                    setMsgText(`Error fetching data: ${error}`);
                    setTimeout(() => {
                        setMsgVisible(false);
                        setMsgText("");
                    }, 3500);
                    setJobInstance([]);
                })
                .finally(() => {
                    document.body.classList.remove("loading-indicator");
                });
        }
    };
    const Dropdowndata = () => {
        var token = sessionStorage.getItem("token");

        if (token && token.length >= 40) {
            document.body.classList.add("loading-indicator");
            const headers = {
                Authorization: `Bearer ${token}`,
            };

            axios
                .get(baseUrl + "/api/Defaultdatum/GetBrokerNames/GetBrokerNames", {
                    headers,
                })
                .then((response) => {
                    if (response.status !== 200) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }

                    const mappedData = response.data
                        .filter(item => item.VchBrokerName !== "ExdionPOD") // REMOVE THIS VALUE
                        .map(({ BrokerId, VchBrokerName }) => ({
                            key: BrokerId.toString(),
                            text: VchBrokerName,
                        }));

                    setBrokeropton(mappedData);
                })
                .catch((error) => {
                    // Handle errors...
                })
                .finally(() => {
                    document.body.classList.remove("loading-indicator");
                });
        }
    };

    const exportData = async (e, row) => {
        const Token = await processAndUpdateToken(sessionStorage.getItem("token"));
        const headers = {
            Authorization: `Bearer ${Token}`,
            "Content-Type": "application/json",
        };
        const apiUrl = `${baseUrl}/api/Excel/QuoteExcelDownloads?Id=` + row?.Id;

        try {
            const response = await axios({
                method: "Get",
                url: apiUrl,
                headers: headers,
                // data: {
                //   Id: row?.Id
                // },
                responseType: "blob",
            });
            if (response.status !== 200) {
                return "error";
            }

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `DeletionReport_${new Date().toLocaleDateString()}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            sessionStorage.setItem("onUpdateClickCalled", false);
            return "success";
        } catch (error) {
            console.error("Error:", error);
            return "error";
        }
    };

    const getData = async (brokerId = null) => {
        let token = sessionStorage.getItem("token");
        document.body.classList.add("loading-indicator");

        token = await processAndUpdateToken(token);

        try {
            const headers = {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };

            // Add broker filter
            const url = brokerId
                ? `${baseUrl}/api/ProcedureData/quotecompare-reports?brokerId=${brokerId}`
                : `${baseUrl}/api/ProcedureData/quotecompare-reports`;

            const response = await axios.get(url, { headers });

            document.body.classList.remove("loading-indicator");

            if (response.status !== 200) {
                throw new Error("Failed to fetch data");
            }

            setJobInstance(response?.data || []);
        } catch (error) {
            document.body.classList.remove("loading-indicator");

            setMsgVisible(true);
            setMsgClass("alert error");
            setMsgText("Error fetching quote compare reports");

            setTimeout(() => {
                setMsgVisible(false);
                setMsgText("");
            }, 3500);

            setJobInstance([]);
        }
    };

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: "12px",
                    gap: "12px"
                }}
            >
                {/* Broker Dropdown */}
                <Dropdown
                    placeholder="Select Broker"
                    selectedKey={selectedBroker}
                    onChange={(event, option) => {
                        onBrokerChange(option.key);
                    }}
                    options={brokeropton}
                    styles={{
                        dropdown: { width: "180px" },
                    }}
                />

                <div style={{ flex: 1 }}>
                    <NewReport
                        activeTab={activeTab}
                        brokerId={selectedBroker}
                        disabled={isDatePickerDisabled}
                        refresh={() => {
                            setSelectedBroker(null);
                            setIsDatePickerDisabled(true); 
                            getData();
                        }}
                    />
                </div>
            </div>

            <CommonDataTable key={1} column={column} data={jobInstance} />
        </div>
    );
};

export default QuoteDeletionReport;
